import clsx from "clsx";
import { FormFieldContext, useError } from "common";
import { useField } from "formik";
import React, { ComponentProps, useContext } from "react";
import { CurrencyInput } from "../Input/CurrencyInput";

interface CurrencyInputFieldProps extends ComponentProps<typeof CurrencyInput> {
    isError?: boolean;
    isRequired?: boolean;
    filterZero?: boolean;
}

export const CurrencyInputField = ({
    placeholder,
    className,
    isRequired,
    isError,
    filterZero = false,
    ...rest
}: CurrencyInputFieldProps) => {
    const name = useContext(FormFieldContext);
    const [field, , helpers] = useField(name);

    const error = useError(name);
    const value =
        (field.value === 0 && filterZero) || field.value === null ? undefined : Number(field.value).toFixed(2);

    return (
        <CurrencyInput
            isError={isError}
            placeholder={placeholder}
            name={name}
            value={value}
            className={clsx(error && "border-danger", className)}
            isRequired={isRequired}
            data-testid="currency-input-field"
            onValueChange={({ floatValue }) => {
                helpers.setValue(floatValue);
            }}
            {...rest}
        />
    );
};
